<template>
	<div>
		<statistics-partials-plain partial-title="Total Putts" :partial-value="roundPutts.total_putts"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Putts Per Hole" :partial-value="roundPutts.putts_per_hole"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Putts Per Gir" :partial-value="roundPutts.putts_per_gir"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Total GIR Putts" :partial-value="roundPutts.total_gir_putts"></statistics-partials-plain>
		<statistics-partials-plain partial-title="No Putts" :partial-value="roundPutts.no_putts"></statistics-partials-plain>
		<statistics-partials-plain partial-title="One Putts" :partial-value="roundPutts.one_putts"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Two Putts" :partial-value="roundPutts.two_putts"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Three Putts" :partial-value="roundPutts.three_putts"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Four Putts" :partial-value="roundPutts.four_putts"></statistics-partials-plain>
	</div>
</template>
<script>
export default {
	name: "StatisticsPutts",
	props: {
		roundPutts: {
			type: Object,
			required: true
		}
	},
	components: {
		'statistics-partials-plain': () => import(/* webpackChunkName: "StatisticsFairways" */ './Partials/Plain'),
	}
}
</script>
